import { render } from "./sys-tabs.vue?vue&type=template&id=0453cc1b"
import script from "./sys-tabs.vue?vue&type=script&lang=js"
export * from "./sys-tabs.vue?vue&type=script&lang=js"

import "./sys-tabs.vue?vue&type=style&index=0&id=0453cc1b&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__